module.exports = __webpack_public_path__ + "img/grenada.c15511a1.svg";